<template>
  <!-- :default-openeds="['1','2','3']" -->
  <el-menu :collapse="isExpand" id="Sidebar" background-color="#01b983" text-color="#fff" active-text-color="#ffd04b" :default-active="$route.path" :unique-opened="false" router >
    <el-menu-item index="/landingPage" >
      <i class="el-icon-document" style="color:#fff"></i>
      <span slot="title">Home</span>
    </el-menu-item>
    <el-submenu  index='1'>
      <template slot="title">
        <i class="el-icon-s-marketing" style="color:#fff"></i>
        <span>Company Information</span>
      </template>
      <el-menu-item index="/magezine">Catalogue Entry</el-menu-item>
      <el-menu-item index="/product">Main Product</el-menu-item>
      <!-- <el-menu-item index="/addProduct">展品上传</el-menu-item> -->
      <el-menu-item index="/productList">Product Image Upload</el-menu-item>
    </el-submenu>
    <el-menu-item index="/card">
      <i class="el-icon-document" style="color:#fff"></i>
      <span slot="title">Exhibitor Badge Application</span>
    </el-menu-item>
    <el-menu-item index="/inviteCode">
      <i class="el-icon-postcard" style="color:#fff"></i>
      <span slot="title">Company Invitation Card</span>
    </el-menu-item>
    <el-submenu index='2'>
      <template slot="title"  >
        <div @click="navTozw" >
          <i class="el-icon-s-ticket" style="color:#fff"></i>
         <span>My Booth</span>
        </div>
      </template>
      <el-menu-item index="/boardInfo"  >Standard Booth</el-menu-item>
      <el-menu-item index="/tz">Raw Space Booth</el-menu-item>
    </el-submenu>
    <el-menu-item index="/activityList"  >
      <i class="el-icon-date" style="color:#fff"></i>
      <span slot="title">Concurrent Conferences</span>
    </el-menu-item>
    <el-submenu index='3'>
      <template slot="title">
        <i class="el-icon-s-ticket" style="color:#fff"></i>
        <span>Marketing Services</span>
      </template>
      <el-menu-item index="/adBook" >CAC Integrated Marketing Solutions</el-menu-item>  
      <el-menu-item index="/fshow">FSHOW Sponsorship Package</el-menu-item>   
    </el-submenu>
    <!-- <el-menu-item index="/lzCode">
      <i class="el-icon-document" style="color:#fff"></i>
      <span slot="title">自助领证码</span>
    </el-menu-item> -->
    <el-menu-item index="/hotel" >
      <i class="el-icon-date" style="color:#fff"></i>
      <span slot="title">Hotel Reservation</span>
    </el-menu-item>
    <el-menu-item index="/yaoqing" >
      <i class="el-icon-collection" style="color:#fff"></i>
      <span slot="title">Invitation Letter</span>
    </el-menu-item>
    <el-menu-item index="/downCenter" >
      <i class="el-icon-download" style="color:#fff"></i>
      <span slot="title">Download Center</span>
    </el-menu-item>
  </el-menu>
</template>

<script>
import api from '@/api'
export default {
  data() {
    return {
      // currentMenuIndex: this.$route.meta.menuIndex.toString(),
      userInfo: {},
      isShowCode:false,
      mainFunList:{},
      companyMuenList: {},
      ztMuenList: {},
      xkMuenList: {},
      atyMuenList: {},
      lzmMuenList: {},
      cooperaMuenList: {},
      typeStr:""      
    }
  },
  created() {
    this.initDashboard()
  },

  mounted() {
    this.getmenulist()
  },

  watch: {},
  computed: {
    isExpand() {
      return this.$store.state.status.isExpand
    },
    // 控制显示的菜单
    isShowMenu() {
      return function(_arr,str) {
        var _arrList = this[_arr]
        if(_arrList.childs){
          for(var i = 0; i<_arrList.childs.length;i++){
              if( _arrList.childs[i].perName == str){
                return true
              }
          }
          return false
        }else{
          return false
        }
      }
    }
  },
  methods: {
    getmenulist() {
      api.getmenulist().then(res => {
        if (res.data.code === 200) {
          var menulist = res.data.data
          for(var i=0;i<menulist.length;i++){
            if(menulist[i].perName == '主要功能'){
              this.mainFunList = menulist[i]
            }
            if(menulist[i].perName == '公司信息'){
              this.companyMuenList = menulist[i]
            }
            if(menulist[i].perName == '我的展台'){
              this.ztMuenList = menulist[i]
            }

            if(menulist[i].perName == '胸卡申请'){
              this.xkMuenList = menulist[i]
            }
            if(menulist[i].perName == '自助领证码'){
              this.lzmMuenList = menulist[i]
            }
            if(menulist[i].perName == '活动列表'){
              this.atyMuenList = menulist[i]
            }

            if(menulist[i].perName == '合作服务'){
              this.cooperaMuenList = menulist[i]
            }
          }
        }
      })
    },
    navTozw(){
      if(this.userInfo.bthBigType=='SS'){
        
          this.$router.push({path:'/boardInfo'})
          // window.location.href = 'https://serv.exporegist.com/nyZfw/#/boardInfo'
        }else{
          this.$router.push({path:'/tz'})
          // window.location.href = 'https://serv.exporegist.com/nyZfw/#/tz'
        }
    },
    navTo(name) {
      if (this.$route.name === name) {
        return false
      }
      this.$router.push(`/${name}`)
    },
    navToLink(link){
      window.open(link, '_blank');
      // window.location.href = link,'_blank'
    },
    initDashboard() {
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
      let duration = ''
      if (!this.userInfo) {
        this.$router.push('/login?ExhID='+localStorage.getItem("ExhID"))
        return
      }
      if (this.userInfo.loginTime === '') {
        this.$router.push('/login?ExhID='+localStorage.getItem("ExhID"))
        return
      }
      if( this.userInfo ){
        if(this.userInfo.bthBigType=='SS'){
          this.isShowCode = true
          this.typeStr = '标准展位'
        }else{
          this.typeStr = '特装展位'
        }          
      }
      duration = (new Date().getTime() - this.userInfo.loginTime) / 1000 / 60 / 60
      // 登陆超过20小时后超时
      if (duration > 20) {
        this.$alert('超时，请重新登录', '', {
          confirmButtonText: '确定',
          callback: (action) => {
            localStorage.removeItem('userInfo')
            this.$router.push('/login?ExhID='+localStorage.getItem("ExhID"))
          }
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
#Sidebar {
  padding-top: 60px;
  height: auto;
  &:not(.el-menu--collapse) {
    width: 280px;
  }
  // .el-menu-item{
  //   padding-left: 10px !important;
  // }
  // .el-submenu__title{
  //   padding-left: 10px !important;
  //   background: red;
  // }
}

@media screen and (max-width:540px){
  // #Sidebar {
  //   position: fixed;
  //   z-index: 10
  // }
}
</style>
